import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginGuard } from '../auth/login-guard';
import { ProjectGuard } from '../helper/project-guard';
import { BaselineInputSummaryComponent } from './baseline/baseline-input-summary/baseline-input-summary.component';
import { BaselineComponent } from './baseline/baseline.component';
import { ResultsComponent } from './results.component';
import { ScenarioComparisonResultsGuard } from './scenario-comparison-results-guard.service';
import { ScenarioListComponent } from './scenario-comparison/scenario-list/scenario-list.component';
import { ScenarioResultsComponent } from './scenario-comparison/scenario-results/scenario-results.component';
import { ScenarioComponent } from './scenario-comparison/scenario.component';
import { CanDeactivateGuard } from '../helper/can-deactivate/can-deactivate.guard';
import { BaselineTechnicalComponent } from './baseline/baseline-technical/baseline-technical.component';
import { BaselineFeedstockBreakdownComponent } from './baseline/baseline-feedstock-breakdown/baseline-feedstock-breakdown.component';
import { BaselineFinancialGeneralComponent } from './baseline/baseline-financial-general/baseline-financial-general.component';
import { BaselineFinancialMetricsComponent } from './baseline/baseline-financial-metrics/baseline-financial-metrics.component';
import { BaselineDebtScheduleComponent } from './baseline/baseline-debt-schedule/baseline-debt-schedule.component';
import { BaselineIncomeStatementComponent } from './baseline/baseline-income-statement/baseline-income-statement.component';
import { BaselineCashFlowAnalysisComponent } from './baseline/baseline-cash-flow-analysis/baseline-cash-flow-analysis.component';
import { SensitivityInputSelectionComponent } from './sensitivity/input-selection/sensitivity-input-selection.component';
import { ValidateGuard } from '../project/validate-guard';
import { SensitivityResultGraphComponent } from './sensitivity/sensitivity-result-graph/sensitivity-result-graph.component';
import { SensitivityComponent } from './sensitivity/sensitivity.component';
import { FlowComponent } from './baseline/flow/flow.component';
import { ResultsGuard } from './results.guard';
import {BaselineSummaryComponent} from './baseline/baseline-summary/baseline-summary.component';
import {BaselineSummaryDetailedComponent} from './baseline/baseline-summary-detailed/baseline-summary-detailed.component';


const resultsRoutes: Routes = [
  {
    path: '', component: ResultsComponent, canActivate: [LoginGuard, ProjectGuard], canActivateChild: [ProjectGuard], children: [
      {
        path: 'baseline', component: BaselineComponent, children: [
          { path: '', redirectTo: '/results', pathMatch: 'full' },
          { path: 'summary', component: BaselineSummaryComponent },
          { path: 'summary-detailed', component: BaselineSummaryDetailedComponent },
          { path: 'technical', component: BaselineTechnicalComponent },
          { path: 'feedstock-breakdown', component: BaselineFeedstockBreakdownComponent },
          { path: 'financial-general', component: BaselineFinancialGeneralComponent, canActivate: [ResultsGuard] },
          { path: 'financial-metrics', component: BaselineFinancialMetricsComponent, canActivate: [ResultsGuard] },
          { path: 'debt-schedule', component: BaselineDebtScheduleComponent, canActivate: [ResultsGuard] },
          { path: 'income-statement', component: BaselineIncomeStatementComponent, canActivate: [ResultsGuard] },
          { path: 'cash-flow-analysis', component: BaselineCashFlowAnalysisComponent, canActivate: [ResultsGuard] },
          // { path: 'overview', component: BaselineOverviewComponent },
          { path: 'input-summary', component: BaselineInputSummaryComponent },
          { path: 'flow-diagram', component: FlowComponent }
        ]
      },
      {
        path: 'sensitivity', component: SensitivityComponent, children: [
          { path: '', redirectTo: '/results', pathMatch: 'full'},
          {
            path: 'input-selection',
            component: SensitivityInputSelectionComponent,
            canActivate: [ProjectGuard, ValidateGuard]
          },
          {
            path: 'sensitivity-results',
            component: SensitivityResultGraphComponent,
            canActivate: [ProjectGuard, ValidateGuard]
          },
        ]
      },
      {
        path: 'scenario', component: ScenarioComponent, children: [
          { path: '', redirectTo: '/results', pathMatch: 'full' },
          {
            path: 'scenario',
            component: ScenarioListComponent,
            canActivate: [ProjectGuard, ValidateGuard],
            canDeactivate: [CanDeactivateGuard]
          },
          {
            path: 'results',
            component: ScenarioResultsComponent,
            canActivate: [ProjectGuard, ValidateGuard, ScenarioComparisonResultsGuard]
          }
        ]
      },
      { path: '**', redirectTo: '/results/baseline/summary'},
    ]
  },
  { path: '**', redirectTo: '/results', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forChild(resultsRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class ResultsRoutingModule { }
